<div [ngClass]="{'field': fieldStyles}">
    <label [for]="formControlName" class="font-medium text-900">
        {{label}}
     </label>
     <p-checkbox
        [id]="formControlName"
        [(ngModel)]="value"
        (ngModelChange)="onChange($event)"
        (blur)="onTouched()"
        [disabled]="isDisabled"
        [binary]="true"
        [class.ng-invalid]="control.invalid && (control.dirty || control.touched)"
        [class.ng-dirty]="control.invalid && (control.dirty || control.touched)"
    />
    <div *ngIf="control?.invalid && (control.dirty || control.touched)" class="text-red-50">
        <small class="text-red-400">{{errorMessage(control)}}</small>
    </div>
</div>
<!--[class.ng-invalid]="control?.invalid && (control.dirty || control.touched)"-->